import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useUpdateEffect from '../../../utils/react/useUpdateEffect';
import { templatePickerVisibleSelector } from '../boardTemplatePickerSelectors';

// Delay the display of the picker to prevent it flashing when dropping
// an element from another board
const TEMPLATE_PICKER_SHOW_DELAY = 200;

// Delay the hiding of the picker to allow fade animation to complete before
// unmounting the template picker completely
const TEMPLATE_PICKER_HIDE_DELAY = 500;

const useShouldRenderTemplatePicker = (currentBoardId: string): boolean => {
    const templatePickerVisible = useSelector(templatePickerVisibleSelector);
    const [shouldRenderTemplatePicker, setShouldRenderTemplatePicker] = useState<boolean>(templatePickerVisible);

    useUpdateEffect(() => {
        const delay = templatePickerVisible ? TEMPLATE_PICKER_SHOW_DELAY : TEMPLATE_PICKER_HIDE_DELAY;

        const timeout = setTimeout(() => {
            setShouldRenderTemplatePicker(templatePickerVisible);
        }, delay);

        return () => {
            clearTimeout(timeout);
        };
    }, [templatePickerVisible]);

    useEffect(() => {
        return () => {
            // Reset the template picker ready state when the current board changes
            setShouldRenderTemplatePicker(false);
        };
    }, [currentBoardId]);

    return shouldRenderTemplatePicker;
};

export default useShouldRenderTemplatePicker;
